<template>
  <div class="offer-actions">
    <div
      v-if="
        item.status === STATUS.ENROLLMENT_OPEN && !item.infinitePlacesAvailable
      "
      class="btn btn--primary flex pdg0"
    >
      <div class="flex text-normalcase status">
        <div class="status__count text-semi">
          {{ item.enrollment.places.available }}
        </div>
        <div class="status__text">
          <div v-if="item.enrollment.places.available > 1">freie Plätze</div>
          <div v-else>freier Platz</div>
          <div class="text-light">verfügbar</div>
        </div>
      </div>
    </div>
    <div
      v-if="
        item.status === STATUS.ENROLLMENT_OPEN && item.infinitePlacesAvailable
      "
      class="btn btn--primary flex pdg0"
    >
      <div class="flex text-normalcase status">
        <div class="status__text unlimited">
          <div>{{ item.enrollment.places.available }}</div>
          <div class="text-light">verfügbar</div>
        </div>
      </div>
    </div>

    <div
      v-if="item.status === STATUS.ENROLLMENT_CLOSED"
      class="btn btn--border flex pdg0"
    >
      <div class="status text-normalcase">
        <div class="status__text">
          <div v-if="item.type === EVENT_TYPE.LESSON">Einschreibezeitraum</div>
          <div v-else>Anmeldezeitraum</div>
          <div class="text-light">abgelaufen</div>
        </div>
      </div>
    </div>

    <div
      v-if="
        item.status === STATUS.ENROLLMENT_FULL &&
        item.type === EVENT_TYPE.LESSON
      "
      class="btn btn--border flex pdg0"
    >
      <div class="status text-normalcase">
        <div class="status__text">
          <div>Keine freien</div>
          <div class="text-light">Plätze mehr</div>
        </div>
      </div>
    </div>

    <div
      v-if="
        item.status === STATUS.ENROLLMENT_FULL &&
        item.type !== EVENT_TYPE.LESSON
      "
      class="btn btn--primary-border flex pdg0"
    >
      <div class="status text-normalcase">
        <div class="status__text">
          <div>Auf Warteliste</div>
          <div class="text-light">setzen</div>
        </div>
      </div>
    </div>

    <div
      v-if="item.status === STATUS.ENROLLMENT_FUTURE"
      class="btn btn--primary-border flex pdg0"
    >
      <div class="status text-normalcase">
        <div class="status__text">
          <div v-if="item.type === EVENT_TYPE.LESSON">Einschreiben möglich</div>
          <div v-else>Anmelden möglich</div>
          <div class="text-light">
            ab {{ item.enrollment.timespan.from.fullDate }}
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="item.status === STATUS.CANCELLED"
      class="btn btn--error-border flex pdg0"
    >
      <div class="status flex flex-center text-normalcase">
        <div class="status__icon">
          <icon :icon-id="'message-error'"></icon>
        </div>
        <div class="status__text text-bold">
          <div>Abgesagt</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { STATUS, EVENT_TYPE } from '@/settings/index'

import Icon from '@/components/Ui/Icon'

export default {
  components: {
    Icon
  },

  props: {
    item: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  data() {
    return {
      STATUS: STATUS,
      EVENT_TYPE: EVENT_TYPE
    }
  }
}
</script>
